import { render, staticRenderFns } from "./OfficeEditEmployees.vue?vue&type=template&id=2865cf98&scoped=true&"
import script from "./OfficeEditEmployees.vue?vue&type=script&lang=js&"
export * from "./OfficeEditEmployees.vue?vue&type=script&lang=js&"
import style0 from "./OfficeEditEmployees.vue?vue&type=style&index=0&id=2865cf98&lang=scss&scoped=true&"
import style1 from "./OfficeEditEmployees.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2865cf98",
  null
  
)

export default component.exports